import { render, staticRenderFns } from "./SuggestionCategory.vue?vue&type=template&id=37a4fa1f&scoped=true"
import script from "./SuggestionCategory.vue?vue&type=script&lang=js"
export * from "./SuggestionCategory.vue?vue&type=script&lang=js"
import style0 from "./SuggestionCategory.vue?vue&type=style&index=0&id=37a4fa1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4fa1f",
  null
  
)

export default component.exports